import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

export default function Page404() {
  return (
    <div id="page-404">
      <Helmet>
        <title>404 | Page Not Found</title>
      </Helmet>
      <p className="err-code">404</p>
      <h1 className="page-title">Page not found<span className="dot">.</span></h1>
      <p className="err-sub">
        This page drifted off the map. Try the <Link to="/">home</Link> page.
      </p>
    </div>
  );
}